import './internal.css';
import { Outlet } from 'react-router-dom';

const Internal = () => {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
};

export default Internal;
